<template>
  <transition
    v-if="transition"
    :name="transition"
    :mode="mode"
    :duration="duration"
    :enter-class="transitionClass(enterClass)"
    :enter-active-class="transitionClass(enterActiveClass)"
    :enter-to-class="transitionClass(enterToClass)"
    :leave-class="transitionClass(leaveClass)"
    :leave-active-class="transitionClass(leaveActiveClass)"
    :leave-to-class="transitionClass(leaveToClass)"
    @before-enter="$emit(&quot;beforeEnter&quot;)"
    @enter="$emit(&quot;enter&quot;)"
    @after-anter="$emit(&quot;afterEnter&quot;)"
    @enter-cancelled="$emit(&quot;enterCancelled&quot;)"
    @before-leave="$emit(&quot;beforeLeave&quot;)"
    @leave="$emit(&quot;leave&quot;)"
    @after-leave="$emit(&quot;afterLeave&quot;)"
    @leave-cancelled="$emit(&quot;leaveCancelled&quot;)"
  >
    <span v-if="waitsFor">
      <slot name="waiting" />
      <span v-if="message">{{ message }}</span>
    </span>
    <div v-else>
      <slot />
    </div>
  </transition>
  <div v-else>
    <span v-if="waitsFor">
      <slot name="waiting" />
      <span v-if="message">{{ message }}</span>
    </span>
    <slot v-else />
  </div>
</template>
<script>
export default {
  props: {
    visible: Boolean,
    for: [String, Array],
    message: String,
    transition: String,
    duration: Number,
    mode: {
      type: String,
      default: 'out-in'
    },
    enterClass: {
      type: String,
      default: 'enter'
    },
    enterActiveClass: {
      type: String,
      default: 'enter-active'
    },
    enterToClass: {
      type: String,
      default: 'enter-to'
    },
    leaveClass: {
      type: String,
      default: 'leave'
    },
    leaveActiveClass: {
      type: String,
      default: 'leave-active'
    },
    leaveToClass: {
      type: String,
      default: 'leave-to'
    }
  },
  emits: ['beforeEnter', 'enter', 'enterCancelled', 'beforeLeave', 'leave', 'afterLeave', 'leaveCancelled', 'afterEnter'],
  computed: {
    waitsFor() {
      if (this.visible) {
        return this.visible
      }
      if (this.for) {
        return this.__$waitInstance.is(this.for)
      }
      return this.__$waitInstance.any
    }
  },
  methods: {
    transitionClass(className) {
      return `${this.transition}-${className}`
    }
  }
}
</script>
